import {
  TRANSACTION_PUT_START,
  TRANSACTION_PUT_ERROR,
  TRANSACTION_PUT_SUCCESS,
} from "../actions/transactions";

import { httpReducer, reduceReducers } from "../lib/create-action";
import { getTransactionForUserActionName } from "../action_managers/transactions";

const initialState = {
  isLoading: false,
  userTransactions: [],
};

function transactionPut(state = initialState, action) {
  switch (action.type) {
    case TRANSACTION_PUT_START:
      return {
        isLoading: true,
      };
    case TRANSACTION_PUT_ERROR:
      return {
        isLoading: false,
      };
    case TRANSACTION_PUT_SUCCESS:
      return {
        isLoading: false,
      };
    default:
      return state;
  }
}

const getTransactionForUser = httpReducer(getTransactionForUserActionName, initialState, {
  success: (state, action) => ({ ...state, userTransactions: action.payload.resp }),
});

export default reduceReducers(transactionPut, getTransactionForUser);
